module.exports = __webpack_public_path__ + "static/media/home-feeling-better1.3eeb440e.svg";